export enum ReviewStatusType {
    unreviewed = '1',
    reviewed = '2',
    skipped = '3'
}